import PlusIcon from '../Assets/plus-sign.png';

const PlusSign = () => {
    return (
        <img src={PlusIcon} alt="Close" className="h-4" />
    );
};

export default PlusSign;